import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Link, Tooltip } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';

import PaginatedTable from './PaginatedTable';
import { nameSort } from '../sorting';
import { getBaseUrl } from '../env';


export default function PlacedCandidatesTable({ candidates, fetchData, loading, totalCount, pageCount, pageSize, role, onEditInvoice }) {

  const navigate = useNavigate();
  const locale = Intl.NumberFormat().resolvedOptions().locale;

  // 1. Create Columns
  const columns = React.useMemo( () => {
    const getUTCDate = (value) => {
      if (!value) return '';
      const date = new Date(value);
      const utc = convertDateToUTC(date);
      return `${utc.toLocaleDateString(locale, {dateStyle:'medium'})}`;
    }

    const convertDateToUTC = (date) => {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    const user = JSON.parse(localStorage.getItem('user'));
    const role = user.role || 'Recruiter';
    const isAdmin = role === 'Manager' || role === 'Administrator';

    const cols = [
    {
      Header: 'Candidate',
      accessor: 'candidate_name',
      Cell: ({value, row}) => {
        const { candidate_id, first_name, last_name } = row.original;
        const url = `/candidate/${candidate_id}`;
        let name = last_name || '';
        if (first_name) name += `, ${first_name}`;

        if (!isAdmin) {
          return name;
        }

        return name ? <Link href={url} onClick={(evt) => {evt.preventDefault();navigate(url)}} underline="hover">{name}</Link> : '';
      },
      sortType: (a, b) => {
        const { first_name: a_first, last_name: a_last } = a.original;
        const { first_name: b_first, last_name: b_last } = b.original;
        return nameSort(a_first, a_last, b_first, b_last);
      }
    },
    {
      Header: 'Salary',
      accessor: 'salary',
    },
    {
      Header: 'Fee',
      accessor: 'fee',
    },
    {
      Header: 'Start Date',
      accessor: 'execution',
      Cell: ({value, row}) => {
        if (!value) return '--';
        return getUTCDate(value);
      }
    },
    {
      Header: 'Recruiter',
      accessor: 'recruiter_id',
      Cell: ({value, row}) => {
        const { recruiter_id, rec_first_name, rec_last_name } = row.original;
        let name = rec_last_name || '';
        if (rec_first_name) name += `, ${rec_first_name}`;

        if (!isAdmin) {
          return name;
        }

        const url = `/recruiter/${recruiter_id}`;
        return <Link href={url} onClick={(evt) => {evt.preventDefault();navigate(url)}} underline="hover">{name}</Link>;
      },
      sortType: (a, b) => {
        const { rec_first_name: a_first, rec_last_name: a_last } = a.original;
        const { rec_first_name: b_first, rec_last_name: b_last } = b.original;
        return nameSort(a_first, a_last, b_first, b_last);
      }
    },
    {
      Header: 'Employer',
      accessor: 'company',
      Cell: ({value, row}) => {
        const { employer_id, company } = row.original;
        const url = `/employer/${employer_id}`;
        return <Link href={url} onClick={(evt) => {evt.preventDefault();navigate(url)}} underline="hover">{company}</Link>;
      }
    },

    /*{
      Header: 'Actions',
      Cell: ({row}) => {
        return <EditIcon onClick={(event) => onEditInvoice(event, row.original, row.index)} sx={{ cursor: 'pointer' }}/>;
      }
    }*/
    ];

    if (isAdmin) {
      cols.push({ 
      Header: 'Invoice',
      accessor: 'invoice',
      Cell: ({value, row}) => {
        const { id, name, employer_id, invoice } = row.original;
        const editUrl = `/empl-attachment/${id}`;
        const imageUrl = `${getBaseUrl()}/v1/employer/${employer_id}/attachment/${id}/download`;
        const viewInvoiceTitle = `View Invoice ${name}`;

        return <Box sx={{ cursor:'pointer' }}>
          <Tooltip title="Edit Invoice Details"><EditIcon onClick={(evt) => {evt.preventDefault();navigate(editUrl)}} sx={{ cursor:'pointer' }}/></Tooltip>
          <Tooltip title={viewInvoiceTitle}><Link href={imageUrl} target="_blank" rel="noreferrer" download underline="hover">{invoice}</Link></Tooltip>
        </Box>;
      }
      });
    }

    return cols;
  },
  [navigate, locale]
 );

  const getRowClasses = (row) => {
    let classes = '';
    return (classes) ? ({ className: classes }) : {};
  }

  // 3. Return the HTML Table
  return (<>
    <PaginatedTable
      data={candidates}
      columns={columns}
      fetchData={fetchData}
      loading={loading}
      totalCount={totalCount}
      pageCount={pageCount}
      pageSize={pageSize}
      getRowClasses={getRowClasses}
      target="Placed Candidates"
    />
  </>);
}

